import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { shouldShowPromoOnlyFooter } from '../../constants/footer';
import './Footer.css';

const Footer = () => {
  const { pathname } = useLocation();
  const year = new Date().getFullYear();
  const showPromoOnly = shouldShowPromoOnlyFooter(pathname);

  return (
    <footer className="app-footer" aria-label="Site footer">
      {!showPromoOnly && (
        <nav className="app-footer__nav" aria-label="Footer links">
          <Link className="app-footer__link" to="/about">
            About
          </Link>
          <Link className="app-footer__link" to="/contact">
            Contact
          </Link>
          <Link className="app-footer__link" to="/privacy">
            Privacy
          </Link>
          <Link className="app-footer__link" to="/terms">
            Terms
          </Link>
        </nav>
      )}
      <div className="app-footer__promo">
        Try our Spatial AI app{' '}
        <a
          className="app-footer__promo-link"
          href="https://brainstormer.chat/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Brainstormer
        </a>{' '}
        for free
      </div>
      {!showPromoOnly && (
        <div className="app-footer__meta">
          © {year} Zoomed In — Playground Logic Sdn Bhd (202501023100 (1624513-K))
        </div>
      )}
    </footer>
  );
};

export default Footer;

